import React from "react";
import HinbanEntryBase from "../../components/HinbanEntryBase";
import HinbanEntryInput from "../../components/HinbanEntryInput";
import HinbanEntryGridAr from "../../components/HinbanEntryGridAr";
import HinbanEntryImages from "../../components/HinbanEntryImages";
import HinbanEntryFiles from "../../components/HinbanEntryFiles";
import HinbanEntryRemarks from "../../components/HinbanEntryRemarks";
import WashGrid from "../../../components/WashGrid";

// パネル種別ごとの本体描画(BASE/グリッド/画像/ファイル/備考/洗濯表示)をまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createSectionContentRenderer(deps) {
    const {
        DicVal,
        G_id,
        GridData,
        KAKOUSIJI_ANCHOR_PANEL_TYPE,
        KAKOUSIJI_SIJISU_TOTAL_PANEL_TYPE,
        ListRowValueChanged,
        ListValueChanged,
        ValueChanged,
        applyBrandHinbanNumberingLockToFields,
        applyHinbanInputControlToFields,
        applyKakousijiCurrencyInputLockColDef,
        buildBaseSearchField,
        buildHinbanWashSaveRows,
        buildKakousijiDemandColumns,
        buildKakousijiGroupFilterVersion,
        buildKakousijiQualityScopeFilterVersion,
        isKakousijiQualityScopeDisplayPanel,
        isKakousijiQualityScopeRowVisible,
        buildKakousijiSijisuTotalRows,
        buildPdtcSizeSelectionColumns,
        buildWashGridFunctionRef,
        columninfo,
        columns,
        controller,
        doesKakousijiGroupSelectionMatchRow,
        edittingcode,
        ensureGridColRef,
        ensureGridDataRef,
        ensureKakousijiSampleInfoRows,
        ensureTotalColRef,
        ensureTotalDataRef,
        entryInitialFocusRef,
        entrydataRef,
        fileRef,
        filterBaseFields,
        filterDetailHeaderGridColumns,
        findKakousijiEntryValue,
        fnc,
        formid,
        gallery,
        getKakousijiDemandRowStyle,
        getKakousijiGridRowsByType,
        handleKakousijiSampleDisplayBaseValueChanged,
        handleKakousijiSampleInfoValueChanged,
        imageRef,
        isEmpty,
        isHinbanGenkaPanel,
        isHinbanWashPanel,
        isKakousijiDemandNouhinPanel,
        isKakousijiDemandPanel,
        isKakousijiGroupManagedPanelType,
        isKakousijiPanel,
        isKakousijiSampleInfoPanel,
        isKakousijiSijisuPanel,
        isKakousijiSoseiPanel,
        isSection220EmptyGrid,
        kakousijiSampleDisplayEntryDataRef,
        kakousijiSampleUpperFields,
        kakousijiSijisuTotalPanel,
        layoutlock,
        onFirstDataRendered,
        onFirstTotalDataRendered,
        readKakousijiRowValueIgnoreCase,
        renderHinbanGenkaSection,
        renderKakousijiNouhinDateBand,
        renderKakousijiSampleLowerSection,
        rerender,
        sectionHeaderData,
        sectionHeaderFields,
        settextfields,
        shouldUseKakousijiDraftNewFormMode,
        sourcePanelForDisplayPanel,
        storeRowData,
        textfields,
        updateSectionHeaderValue
    } = deps;

    function renderDetailSectionHeaderInline(panelInfo, sectionLock) {
        const fields = applyHinbanInputControlToFields(sectionHeaderFields(panelInfo));
        if (fields.length === 0) return null;
        const dataRef = { current: sectionHeaderData(panelInfo) };
        return (
            <div className="hinban-section-header-inline">
                {fields.map((field) => (
                    <div key={field.columnid} className="hinban-section-header-field">
                        <div className="hinban-section-header-label">
                            {field.columnnm}
                        </div>
                        <div className="fieldinput hinban-section-header-input">
                            <HinbanEntryInput
                                def={field}
                                dataRef={dataRef}
                                textfields={fields}
                                fnc={buildWashGridFunctionRef(panelInfo)}
                                QuerySearchClick={buildBaseSearchField}
                                ValueChanged={(id, value, edit, options) => {
                                    updateSectionHeaderValue(panelInfo, id, value);
                                    ValueChanged(id, value, edit, options);
                                }}
                                sectionLock={sectionLock}
                                forceNewFormMode={shouldUseKakousijiDraftNewFormMode(panelInfo)}
                            />
                        </div>
                    </div>
                ))}
            </div>
        );
    }
    function renderKakousijiSijisuTotalGrid(panelInfo) {
        const totalPanel = kakousijiSijisuTotalPanel(panelInfo);
        const totalDataRef = ensureTotalDataRef(totalPanel);
        if (!Array.isArray(totalDataRef.current)) {
            totalDataRef.current = buildKakousijiSijisuTotalRows(GridData(panelInfo));
        }
        return (
            <div className="hinban-sijisu-total-grid-wrap">
                <HinbanEntryGridAr
                    id={fnc.current.GridID(panelInfo) + '_total_' + KAKOUSIJI_SIJISU_TOTAL_PANEL_TYPE}
                    entrydataRef={entrydataRef}
                    dataRef={totalDataRef}
                    columnRef={ensureTotalColRef(totalPanel)}
                    columninfo={columninfo}
                    columns={columns}
                    fnc={buildWashGridFunctionRef(panelInfo)}
                    onFirstDataRendered={(params) => onFirstTotalDataRendered(params, totalPanel)}
                    formid={formid}
                    ValueChanged={() => {}}
                    RowValueChanged={() => {}}
                    panel={totalPanel}
                    total={true}
                    rowDrag={false}
                    />
                </div>
        );
    }
    function renderKakousijiSijisuSection(panelInfo, filteredColumnInfo, filteredColumns) {
        return (
            <React.Fragment>
                <div>
                    <div className='hinban-kakousiji-grid hinban-kakousiji-sijisu-grid'>
                        <HinbanEntryGridAr
                            id={fnc.current.GridID(panelInfo)}
                            entrydataRef={entrydataRef}
                            dataRef={ensureGridDataRef(panelInfo)}
                            columnRef={ensureGridColRef(panelInfo)}
                            columninfo={filteredColumnInfo}
                            columns={filteredColumns}
                            fnc={buildWashGridFunctionRef(panelInfo)}
                            onFirstDataRendered={onFirstDataRendered}
                            formid={formid}
                            ValueChanged={(params) => ListValueChanged(params, panelInfo)}
                            RowValueChanged={(colid, rows) => ListRowValueChanged(colid, rows, panelInfo)}
                            panel={panelInfo}
                        />
                    </div>
                    {renderKakousijiSijisuTotalGrid(panelInfo)}
                </div>
            </React.Fragment>
        );
    }
    function renderKakousijiSampleBaseAndLower(panelInfo, fallbackFields = null) {
        const baseid = 'basepanel' + panelInfo.type;
        const upperFields = kakousijiSampleUpperFields(panelInfo, fallbackFields);
        const basePanelInfo = { ...panelInfo, id: G_id.BASE, grid: false };
        const sampleRows = ensureKakousijiSampleInfoRows(panelInfo);
        const sampleEntryDataRef = { current: DicVal(sampleRows, 0, {}) };
        return (
            <div id={baseid}>
                <HinbanEntryBase
                    fnc={fnc}
                    textfields={upperFields}
                    settextfields={settextfields}
                    panel={basePanelInfo}
                    QuerySearchClick={buildBaseSearchField}
                    ValueChanged={(id, value, edit, options) => handleKakousijiSampleInfoValueChanged(panelInfo, id, value, edit, options)}
                    entrydataRef={sampleEntryDataRef}
                    layoutlock={layoutlock}
                    showimage={false}
                    initialFocusRef={entryInitialFocusRef}
                    forceNewFormMode={shouldUseKakousijiDraftNewFormMode(panelInfo)}
                    ignoreStoreEntryData={true}
                />
                {renderKakousijiSampleLowerSection(panelInfo)}
            </div>
        );
    }
    function renderContents(panelInfo) {
        // パネル種別ごとに表示コンポーネントを切り替える
        const sourcePanelInfo = sourcePanelForDisplayPanel(panelInfo);
        const sampleDisplayEntryKey = String(DicVal(panelInfo, 'sampleEntryKey', '')).trim();
        if (isKakousijiSampleInfoPanel(panelInfo) && sourcePanelInfo.id !== G_id.BASE) {
            return renderKakousijiSampleBaseAndLower(panelInfo);
        }
        if (sourcePanelInfo.id === G_id.BASE) {
            if (isKakousijiSampleInfoPanel(panelInfo)) return renderKakousijiSampleBaseAndLower(panelInfo, textfields);
            const baseid = String(DicVal(panelInfo, 'sampleDisplayKey', '')) || ("basepanel" + panelInfo.type);
            const baseTextFields = applyHinbanInputControlToFields(applyBrandHinbanNumberingLockToFields(filterBaseFields(textfields, sourcePanelInfo)));
            const baseEntryDataRef = sampleDisplayEntryKey === '' ? entrydataRef : kakousijiSampleDisplayEntryDataRef(panelInfo);
            const baseValueChanged = sampleDisplayEntryKey === '' ? ValueChanged : ((id, value, edit, options) => handleKakousijiSampleDisplayBaseValueChanged(panelInfo, id, value, edit, options));
            return (
                <div id={baseid} >
                <HinbanEntryBase
                    fnc={fnc}
                    textfields={baseTextFields}
                    settextfields={settextfields}
                    panel={sourcePanelInfo}
                    QuerySearchClick={buildBaseSearchField}
                    ValueChanged={baseValueChanged}
                    entrydataRef={baseEntryDataRef}
                    layoutlock={layoutlock}
                    showimage={gallery && panelInfo.type === '100'}
                    initialFocusRef={entryInitialFocusRef}
                    forceNewFormMode={shouldUseKakousijiDraftNewFormMode(panelInfo)}
                    ignoreStoreEntryData={sampleDisplayEntryKey !== ''}
                />
                </div>
            );
        }
        if (panelInfo.id === G_id.IMAGE) {
            return (
                <HinbanEntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        // if (panelInfo.grid) {
        //     const filteredColumnInfo = filterDetailHeaderGridColumns(columninfo, panelInfo);
        //     const filteredColumns = filterDetailHeaderGridColumns(columns, panelInfo);
        //     if (panelInfo.id !== G_id.PL) {
        //         return (
        //             <React.Fragment>
        //                 <HinbanEntryGridAr
        //                     id={ fnc.current.GridID(panelInfo)}
        //                     entrydataRef={entrydataRef}
        //                     dataRef={ensureGridDataRef(panelInfo)}
        //                     columnRef={ensureGridColRef(panelInfo)}
        //                     columninfo={filteredColumnInfo}
        //                     columns={filteredColumns}
        //                     fnc={fnc}
        //                     onFirstDataRendered={onFirstDataRendered}
        //                     formid={formid}
        //                     ValueChanged={(params) => ListValueChanged(params, panelInfo)}
        //                     RowValueChanged={(colid, rows) => ListRowValueChanged(colid, rows, panelInfo)}
        //                     panel={panelInfo}
        //                 />
        //             </React.Fragment>
        //         );
        //     } else {
        //         return (
        //             <HinbanEntryGridAr
        //                 id={fnc.current.GridID(panelInfo)}
        //                 entrydataRef={entrydataRef}
        //                 dataRef={ensureGridDataRef(panelInfo)}
        //                 columnRef={ensureGridColRef(panelInfo)}
        //                 columninfo={filteredColumnInfo}
        //                 columns={filteredColumns}
        //                 fnc={fnc}
        //                 onFirstDataRendered={onFirstDataRendered}
        //                 formid={formid}
        //                 ValueChanged={(params) => ListValueChanged(params, panelInfo)}
        //                 RowValueChanged={(colid, rows) => ListRowValueChanged(colid, rows, panelInfo)}
        //                 panel={panelInfo}
        //             />
        //         );
        //     }
        // }
        if (panelInfo.grid) {
            if (isHinbanWashPanel(panelInfo)) {
                return (
                    <React.Fragment>
                        <WashGrid
                            id={fnc.current.GridID(panelInfo)}
                            table="d_inst_wash"
                            entrydataRef={entrydataRef}
                            dataRef={ensureGridDataRef(panelInfo)}
                            columnRef={ensureGridColRef(panelInfo)}
                            type={String(panelInfo.type ?? '')}
                            fnc={buildWashGridFunctionRef(panelInfo)}
                            onFirstDataRendered={onFirstDataRendered}
                            ValueChanged={(params) => ListValueChanged(params, panelInfo)}
                            RowValueChanged={() => ListRowValueChanged('', buildHinbanWashSaveRows(GridData(panelInfo)), panelInfo)}
                            RemoveRow={() => storeRowData(panelInfo)}
                            panel={panelInfo}
                        />
                    </React.Fragment>
                );
            }
            const filteredColumnInfo = applyHinbanInputControlToFields(filterDetailHeaderGridColumns(columninfo, panelInfo));
            const filteredColumns = applyHinbanInputControlToFields(filterDetailHeaderGridColumns(columns, panelInfo));
            const isDemandPanel = isKakousijiDemandPanel(panelInfo);
            const isHinbanGenka = isHinbanGenkaPanel(panelInfo);
            const isKakousijiGrid = isKakousijiPanel(panelInfo) || String(DicVal(panelInfo, 'type', '')).trim() === KAKOUSIJI_ANCHOR_PANEL_TYPE;
            const isPdtcDetailGrid = ["200", "210", "220", "230"].includes(String(DicVal(panelInfo, 'type', '')).trim());
            const gridClassName = [
                isKakousijiGrid ? 'hinban-kakousiji-grid' : '',
                isDemandPanel ? 'hinban-kakousiji-demand-grid' : '',
                isSection220EmptyGrid(panelInfo) ? 'hinban-section220-empty-grid' : '',
                // カラー/サイズ/SKU/セットアイテムはデータ0件でも空行込み2行分の高さを確保する
                isPdtcDetailGrid ? 'hinban-pdtc-min-rows-grid' : ''
            ].filter(v => v !== '').join(' ');
            const pdtcSizeQuerySetColumn = (colDef) => buildPdtcSizeSelectionColumns(colDef);
            const demandQuerySetColumn = (colDef) => buildKakousijiDemandColumns(panelInfo, colDef);
            const gridQuerySetColumn = (colDef) => {
                let nextColDef = colDef;
                if (String(DicVal(panelInfo, 'type', '')).trim() === "210") nextColDef = pdtcSizeQuerySetColumn(nextColDef);
                if (isDemandPanel) nextColDef = demandQuerySetColumn(nextColDef);
                return nextColDef;
            };
            const demandRowStyle = getKakousijiDemandRowStyle(panelInfo);

            if (isHinbanGenka) {
                return renderHinbanGenkaSection(panelInfo, filteredColumnInfo, filteredColumns);
            }
            if (isKakousijiSijisuPanel(panelInfo)) {
                return renderKakousijiSijisuSection(panelInfo, filteredColumnInfo, filteredColumns);
            }
            return (
                <React.Fragment>
                    <div className={gridClassName}>
                        <HinbanEntryGridAr
                            id={fnc.current.GridID(panelInfo)}
                            entrydataRef={entrydataRef}
                            dataRef={ensureGridDataRef(panelInfo)}
                            columnRef={ensureGridColRef(panelInfo)}
                            columninfo={filteredColumnInfo}
                            columns={filteredColumns}
                            fnc={buildWashGridFunctionRef(panelInfo)}
                            onFirstDataRendered={onFirstDataRendered}
                            formid={formid}
                            ValueChanged={(params) => ListValueChanged(params, panelInfo)}
                            RowValueChanged={(colid, rows) => ListRowValueChanged(colid, rows, panelInfo)}
                            panel={panelInfo}
                            QuerySearchClick={buildBaseSearchField}
                            QuerySetColumn={(String(DicVal(panelInfo, 'type', '')).trim() === "210" || isDemandPanel) ? gridQuerySetColumn : undefined}
                            // 通貨単位による単価/金額の入力制御（可否＋背景色）
                            ColdefSpecial={applyKakousijiCurrencyInputLockColDef}
                            getRowStyle={isDemandPanel ? demandRowStyle : undefined}
                            rowDrag={isHinbanGenka ? false : undefined}
                            externalRowFilter={isKakousijiGroupManagedPanelType(DicVal(panelInfo, 'type', ''))
                                ? ((row) => doesKakousijiGroupSelectionMatchRow(DicVal(panelInfo, 'type', ''), row))
                                : (isKakousijiQualityScopeDisplayPanel(panelInfo)
                                    ? ((row) => isKakousijiQualityScopeRowVisible(DicVal(panelInfo, 'type', ''), row))
                                    : undefined)}
                            externalFilterVersion={isKakousijiQualityScopeDisplayPanel(panelInfo)
                                ? buildKakousijiQualityScopeFilterVersion(DicVal(panelInfo, 'type', ''))
                                : buildKakousijiGroupFilterVersion(DicVal(panelInfo, 'type', ''))}
                            disableEntryDataMerge={isKakousijiGroupManagedPanelType(DicVal(panelInfo, 'type', ''))
                                || isKakousijiSoseiPanel(panelInfo)
                                // 副資材スコープの表示専用グリッド(小物札/ブランドネーム/その他ネーム/その他副資材)は
                                // 代表行から組み立てた表示行のため entrydata をマージしない(表示値の上書き防止)
                                || ['121', '122', '123', '124'].includes(String(DicVal(panelInfo, 'type', '')).trim())}
                        />
                    </div>
                </React.Fragment>
            );
        }
        if (panelInfo.id === G_id.FILE) {
            return (
                <HinbanEntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        if (panelInfo.id === G_id.NB) {
            if (isEmpty(columninfo)) return null;
            let coldef = applyHinbanInputControlToFields([columninfo.find(e => e.type === panelInfo.type)])[0];
            return (
                <HinbanEntryRemarks
                    id={"remarkspanel" + panelInfo.type}
                    def={coldef}
                    dataRef={entrydataRef}
                    fnc={fnc}
                    ValueChanged={ValueChanged}
                    forceNewFormMode={shouldUseKakousijiDraftNewFormMode(panelInfo)}
                />
            )
        }
        return null;

    }
    function formatKakousijiNouhinDateLabel(raw) {
        const s = String(raw ?? '').trim();
        if (s === '') return '';

        const ymd = s.match(/^(\d{4})[\/\-\.](\d{1,2})[\/\-\.](\d{1,2})(?:\s+\d{1,2}:\d{1,2}(?::\d{1,2})?)?$/);
        if (ymd) {
            const m = Number(ymd[2]);
            const d = Number(ymd[3]);
            if (Number.isFinite(m) && Number.isFinite(d)) return m + '月' + d + '日';
        }

        const iso = s.match(/^(\d{4})[\/\-\.](\d{1,2})[\/\-\.](\d{1,2})T\d{1,2}:\d{1,2}(?::\d{1,2})?$/);
        if (iso) {
            const m = Number(iso[2]);
            const d = Number(iso[3]);
            if (Number.isFinite(m) && Number.isFinite(d)) return m + '月' + d + '日';
        }

        const ymd8 = s.match(/^(\d{4})(\d{2})(\d{2})$/);
        if (ymd8) {
            const m = Number(ymd8[2]);
            const d = Number(ymd8[3]);
            if (Number.isFinite(m) && Number.isFinite(d)) return m + '月' + d + '日';
        }

        return s;
    }
    function getKakousijiNouhinHeaderRows(panelInfo) {
        if (isEmpty(panelInfo)) return [];
        const rows = getKakousijiGridRowsByType(String(DicVal(panelInfo, 'type', '')).trim());
        return Array.isArray(rows) ? rows : [];
    }
    function firstKakousijiNouhinDateFromRows(rows, candidates) {
        const list = Array.isArray(rows) ? rows : [];
        const keys = Array.isArray(candidates) ? candidates : [];

        for (let i = 0; i < list.length; i += 1) {
            const row = list[i];
            for (let j = 0; j < keys.length; j += 1) {
                const value = String(readKakousijiRowValueIgnoreCase(row, keys[j]) ?? '').trim();
                if (value !== '') return value;
            }
        }
        return '';
    }
    function resolveKakousijiNouhinDateBand(panelInfo) {
        const rows = getKakousijiNouhinHeaderRows(panelInfo);

        const siireDate = String(findKakousijiEntryValue(entrydataRef.current, ['SSRM_SIIREBI']) ?? '');
        const nouhinDate = String(findKakousijiEntryValue(entrydataRef.current, ['SSDNY_NOUHINYOTEI']) ?? '');
        const centerDate = String(findKakousijiEntryValue(entrydataRef.current, ['SSDNY_CENTER']) ?? '');
        const part1Date = String(findKakousijiEntryValue(entrydataRef.current, ['SSDNY_PART1']) ?? '');
        const part2Date = String(findKakousijiEntryValue(entrydataRef.current, ['SSDNY_PART2']) ?? '');
        const part3Date = String(findKakousijiEntryValue(entrydataRef.current, ['SSDNY_PART3']) ?? '');
        const part4Date = String(findKakousijiEntryValue(entrydataRef.current, ['SSDNY_PART4']) ?? '');

        return {
            toinyu: '',
            siire: formatKakousijiNouhinDateLabel(siireDate || firstKakousijiNouhinDateFromRows(rows, ['SSRM_SIIREBI'])),
            nouhin: formatKakousijiNouhinDateLabel(nouhinDate || firstKakousijiNouhinDateFromRows(rows, ['SSDNY_NOUHINYOTEI'])),
            center: formatKakousijiNouhinDateLabel(centerDate || firstKakousijiNouhinDateFromRows(rows, ['SSDNY_CENTER'])),
            part1: formatKakousijiNouhinDateLabel(part1Date || firstKakousijiNouhinDateFromRows(rows, ['SSDNY_PART1'])),
            part2: formatKakousijiNouhinDateLabel(part2Date || firstKakousijiNouhinDateFromRows(rows, ['SSDNY_PART2'])),
            part3: formatKakousijiNouhinDateLabel(part3Date || firstKakousijiNouhinDateFromRows(rows, ['SSDNY_PART3'])),
            part4: formatKakousijiNouhinDateLabel(part4Date || firstKakousijiNouhinDateFromRows(rows, ['SSDNY_PART4'])),
            zansu: ''
        };
    }

    return {
        renderDetailSectionHeaderInline,
        renderKakousijiSijisuTotalGrid,
        renderKakousijiSijisuSection,
        renderKakousijiSampleBaseAndLower,
        renderContents,
        formatKakousijiNouhinDateLabel,
        getKakousijiNouhinHeaderRows,
        firstKakousijiNouhinDateFromRows,
        resolveKakousijiNouhinDateBand
    };
}
